import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
import $ from "jquery";
import { BsChevronDown, BsHouse, BsShopWindow } from "react-icons/bs";
import { PiBed, PiWhatsappLogoDuotone, PiX } from "react-icons/pi";
import { useStateContext } from "../../context/ContextProvider";
import { useNavigate } from "react-router-dom";
import Loading from "../Loading/Loading";
import { enquiryOptions } from "../../options/EnquiryOptions";
import { propertyOptions } from "../../options/PropertyOptions";
import { FaChevronDown } from "react-icons/fa";
import CryptoJS from "crypto-js";
import { bgMap, neonMap, textMap, vectorMap } from "../ColorMappingOptions";
import { sendTikTokEvent } from "../../utils/TikTokEventsApi";
import { sendSnapchatEvent } from "../../utils/SnapchatEventsApi";

// Function to hash data with SHA-256
export const hashData = (data) => {
  if (!data) return "";
  return CryptoJS.SHA256(data.toLowerCase()).toString(CryptoJS.enc.Hex);
};

const ColorLeadForm = ({
  color = "orange",
  base_url,
  developer,
  project,
  leadType = "Apartment",
  leadSource,
  language,
  enquiries = null,
  jacuzzi = false,
  purpose = null,
  askEmail = false,
  assignedToManager,
  assignedToSales,
  otpCode = null,
  contactTime = false,
}) => {
  const { t, userInfo } = useStateContext();

  const navigate = useNavigate();

  const optionsConfig = enquiryOptions(t, jacuzzi);
  const propertyConfig = propertyOptions(t);

  const [formData, setFormData] = useState({
    leadName: "",
    leadContact: "",
    leadEmail: "",
    country: userInfo?.state + ", " + userInfo?.countryName ?? "",
    developer: developer ?? "",
    project: project ?? "",
    projectName: project ?? "",
    enquiryType: "",
    leadFor: "",
    // leadType: leadType ?? "Apartment",
    leadType: typeof leadType === "string" ? leadType : "",
    language: language ?? "",
    leadSource: leadSource ?? "Website",
    filename: "",
    ip: userInfo?.ip ?? "",
    device: userInfo?.userAgent ?? "",
    notes: "",
    assignedToManager: assignedToManager ?? null,
    assignedToSales: assignedToSales ?? null,
    otp: otpCode ? "Not Verified" : "No OTP Used",
    timezone: "",
    time: "",
    // CAMPAIGN DETAILS 
    campaign_id: "",
    campaign_name: "",
    ad_id: "",
    ad_name: "",
    adset_id: "",
    adset_name: "",
  });

  // CAMPAIGN PARAMS FROM URL
  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);

    const campaignData = {
      campaign_id: urlParams.get("campaign_id") || "",
      campaign_name: urlParams.get("campaign_name") || "",
      ad_id: urlParams.get("ad_id") || "",
      ad_name: urlParams.get("ad_name") || "",
      adset_id: urlParams.get("adset_id") || "",
      adset_name: urlParams.get("adset_name") || "",
    };

    setFormData((prev) => ({
      ...prev,
      ...campaignData,
    }));

    // Optional debug
    // console.log("Campaign Params:", campaignData);
  }, []);

  useEffect(() => {
    if (otpCode) {
      setFormData((prev) => ({
        ...prev,
        otp_code: otpCode,
      }));
    }
  }, [otpCode]); // Depend on otpCode, not formData

  const isOutsideUAE = userInfo?.countryName !== "United Arab Emirates";

  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const [showForm, setShowForm] = useState(true);
  const [countryCode, setCountryCode] = useState("");
  const [localNumber, setLocalNumber] = useState("");
  const [isValid, setIsValid] = useState(true);
  const [time, setTime] = useState("");
  const [click, setClick] = useState(null);

  // OTP
  const [showOtpForm, setShowOtpForm] = useState(false);
  const [otp, setOtp] = useState(["", "", "", "", "", ""]);
  const [otpError, setOtpError] = useState("");
  const [attempts, setAttempts] = useState(0);
  const [serverOtp, setServerOtp] = useState(null);
  const [leadId, setLeadId] = useState(null);
  const [resendTimer, setResendTimer] = useState(60);
  const [isResendDisabled, setIsResendDisabled] = useState(true);

  const contactFieldRef = useRef(null);
  const contactErrorRef = useRef(null);
  const submitBtnRef = useRef(null);
  const timeInputRef = useRef(null);
  const otpRefs = useRef([null, null, null, null, null, null]);
  const otpSubmitBtnRef = useRef(null);

  const [selectedPropertyType, setSelectedPropertyType] = useState(
    typeof leadType === "string" ? leadType : "",
  );
  // Determine if leadType is in the new format (array of objects)
  const isNewLeadTypeFormat =
    Array.isArray(leadType) &&
    leadType.length > 0 &&
    typeof leadType[0] === "object";

  // Get bedroom options for the selected property type
  const getBedroomOptions = () => {
    if (enquiries) {
      if (!isNewLeadTypeFormat) {
        return enquiries;
      }
      const leadTypeObj = leadType[0];
      return leadTypeObj[selectedPropertyType] || [];
    }
  };

  // Normalize a raw enquiries item (string OR object) into a consistent option shape
  const normalizeOption = (item) => {
    // NEW FORMAT: { label, enquiryType, leadType }
    if (typeof item === "object" && item !== null) {
      const value = item.enquiryType || item.label;
      return {
        key: value,
        option: {
          value,
          label: item.label,
          leadType: item.leadType || null,
        },
      };
    }
    // OLD FORMAT: string key that exists in optionsConfig
    const configOption = optionsConfig[item];
    if (configOption) return { key: item, option: { ...configOption, leadType: null } };
    // OLD FORMAT: raw string, use as-is
    return { key: item, option: { value: item, label: item, leadType: null } };
  };

  // Normalize input to Latin characters
  const normalizeToLatin = (value, type) => {
    if (type === "tel") {
      // Convert Persian/Arabic digits to Latin digits
      const persianDigits = [
        /۰/g,
        /۱/g,
        /۲/g,
        /۳/g,
        /۴/g,
        /۵/g,
        /۶/g,
        /۷/g,
        /۸/g,
        /۹/g,
      ];
      const arabicDigits = [
        /٠/g,
        /١/g,
        /٢/g,
        /٣/g,
        /٤/g,
        /٥/g,
        /٦/g,
        /٧/g,
        /٨/g,
        /٩/g,
      ];
      let normalized = value;
      for (let i = 0; i < 10; i++) {
        normalized = normalized
          .replace(persianDigits[i], i)
          .replace(arabicDigits[i], i);
      }
      // Allow only Latin digits, +, -, and spaces
      return normalized.replace(/[^0-9+\-\s]/g, "");
    } else if (type === "email") {
      // Allow only Latin letters, digits, and common email characters
      return value.replace(/[^A-Za-z0-9@._\-]/g, "");
    } else if (type === "name") {
      // Allow only letters (Latin for English/Turkish/French, Arabic/Persian) and spaces
      return value.replace(
        /[^A-Za-z\u00C0-\u017F\u0600-\u06FF\u0750-\u077F\s]/g,
        "",
      );
    } else if (type === "otp") {
      // Normalize digits from various scripts to Latin digits
      const digitMap = {
        // Arabic
        "٠": "0",
        "١": "1",
        "٢": "2",
        "٣": "3",
        "٤": "4",
        "٥": "5",
        "٦": "6",
        "٧": "7",
        "٨": "8",
        "٩": "9",
        // Persian
        "۰": "0",
        "۱": "1",
        "۲": "2",
        "۳": "3",
        "۴": "4",
        "۵": "5",
        "۶": "6",
        "۷": "7",
        "۸": "8",
        "۹": "9",
        // Hindi (Devanagari)
        "०": "0",
        "१": "1",
        "२": "2",
        "३": "3",
        "४": "4",
        "५": "5",
        "६": "6",
        "७": "7",
        "८": "8",
        "९": "9",
        // Bengali
        "০": "0",
        "১": "1",
        "২": "2",
        "৩": "3",
        "৪": "4",
        "৫": "5",
        "৬": "6",
        "৭": "7",
        "৮": "8",
        "৯": "9",
        // Thai
        "๐": "0",
        "๑": "1",
        "๒": "2",
        "๓": "3",
        "๔": "4",
        "๕": "5",
        "๖": "6",
        "๗": "7",
        "๘": "8",
        "๙": "9",
        // Chinese (full-width)
        "０": "0",
        "１": "1",
        "２": "2",
        "３": "3",
        "４": "4",
        "５": "5",
        "６": "6",
        "７": "7",
        "８": "8",
        "９": "9",
      };
      return value
        .split("")
        .map((char) => digitMap[char] || char)
        .join("")
        .replace(/[^0-9]/g, "")
        .slice(0, 1);
    }
    return value;
  };

  // CHECK DEVICE
  const [isAndroid, setIsAndroid] = useState(false);

  // AUTO-SET ENQUIRY TYPE WHEN ONLY ONE BEDROOM OPTION EXISTS
  useEffect(() => {
    if (!enquiries) return;

    // const bedroomOptions = getBedroomOptions() || [];
    // const validOptions = bedroomOptions
    //   .map((key) => optionsConfig[key])
    //   .filter(Boolean);

    // const bedroomOptions = getBedroomOptions() || [];
    // const validOptions = bedroomOptions.map((key) => optionsConfig[key] || { value: key, label: key });

    const bedroomOptions = getBedroomOptions() || [];
    const validOptions = bedroomOptions.map((item) => normalizeOption(item).option);

    if (validOptions.length === 1) {
      setFormData((prev) => ({
        ...prev,
        enquiryType: validOptions[0].value,
        ...(validOptions[0].leadType && !isNewLeadTypeFormat
          ? { leadType: validOptions[0].leadType }
          : {}),
      }));
    }

    // if (validOptions.length === 1) {
    //   setFormData((prev) => ({
    //     ...prev,
    //     enquiryType: validOptions[0].value,
    //   }));
    // } else if (validOptions.length === 0) {
    //   // No valid options — clear it out just in case
    //   setFormData((prev) => ({
    //     ...prev,
    //     enquiryType: prev.enquiryType, // no-op, left as-is intentionally
    //   }));
    // }
  }, [selectedPropertyType, enquiries]);

  useEffect(() => {
    const android = /Android/i.test(navigator.userAgent);
    setIsAndroid(android);
  }, []);

  // CHECK LAST SUBMISSION
  useEffect(() => {
    const checkLastSubmission = () => {
      const lastSubmission = localStorage.getItem("leadFormSubmission");
      if (lastSubmission) {
        const timeElapsed = Date.now() - parseInt(lastSubmission, 10);
        if (timeElapsed < 120000) {
          setShowForm(false);
          setLoading(false);
          return;
        }
      }
      setShowForm(true);
    };
    checkLastSubmission();
    setLoading(false);
  }, []);

  // OTP TIMER
  useEffect(() => {
    let timer;
    if (showOtpForm && resendTimer > 0) {
      setIsResendDisabled(true);
      timer = setInterval(() => {
        setResendTimer((prev) => {
          if (prev <= 1) {
            clearInterval(timer);
            setIsResendDisabled(false);
            return 0;
          }
          return prev - 1;
        });
      }, 1000);
    }
    return () => clearInterval(timer);
  }, [showOtpForm, resendTimer]);

  // URL PATH / FILENAME
  useEffect(() => {
    const path = window.location.pathname;
    const query = window.location.search;
    const fullUrl = window.location.href;
    const fullPath = path + query;
    setFormData((prevData) => ({
      ...prevData,
      filename: fullUrl,
      language: language,
    }));
  }, []);

  // DEVICE
  useEffect(() => {
    setFormData((prevData) => ({
      ...prevData,
      device: userInfo?.userAgent ?? "",
      language: language,
    }));
  }, [userInfo]);

  // SOURCE OF LEAD
  useEffect(() => {
    // GET CURRENT URL
    const urlParams = new URLSearchParams(window.location.search);
    const fullUrl = window.location.href.toLowerCase();
    let leadSource = localStorage.getItem("leadSource") || null; // Check stored source first
    let clickId = null;

    // Check if stored data is stale (e.g., older than 24 hours)
    const lastStored = localStorage.getItem("leadSourceTimestamp");
    if (lastStored && Date.now() - parseInt(lastStored) > 24 * 60 * 60 * 1000) {
      localStorage.removeItem("leadSource");
      localStorage.removeItem("originalReferrer");
      localStorage.removeItem("leadSourceTimestamp");
      leadSource = null;
    }

    // Store original referrer on first load
    if (!localStorage.getItem("originalReferrer")) {
      localStorage.setItem("originalReferrer", document.referrer || "");
    }

    // 1. Check click IDs (highest priority)
    if (urlParams.has("gclid")) {
      leadSource = "GoogleAds";
      clickId = urlParams.get("gclid");
    } else if (urlParams.has("ttclid")) {
      leadSource = "TikTok";
      clickId = urlParams.get("ttclid");
    } else if (urlParams.has("sccid")) {
      leadSource = "Snapchat";
      clickId = urlParams.get("sccid");
    } else if (urlParams.has("fbclid")) {
      leadSource = "Facebook";
      clickId = urlParams.get("fbclid");
    } else if (urlParams.has("twclid")) {
      leadSource = "X";
      clickId = urlParams.get("twclid");
    } else if (urlParams.has("utm_source")) {
      // 2. Check UTM parameters
      const utmSource = urlParams.get("utm_source").toLowerCase();
      const sourceMap = {
        google: "GoogleAds",
        facebook: "Facebook",
        fb: "Facebook",
        instagram: "Instagram",
        tiktok: "TikTok",
        snapchat: "Snapchat",
        twitter: "X",
        x: "X",
        linkedin: "LinkedIn",
      };
      leadSource = sourceMap[utmSource] || utmSource;
    } else {
      // 3. Check stored referrer or current referrer
      const referrer =
        localStorage.getItem("originalReferrer") ||
        document.referrer.toLowerCase();
      if (referrer) {
        if (
          referrer.includes("google.com") ||
          referrer.includes("googleadservices.com")
        ) {
          leadSource = "GoogleAds";
        } else if (
          referrer.includes("facebook.com") ||
          referrer.includes("fb.com")
        ) {
          leadSource = "Facebook";
        } else if (referrer.includes("instagram.com")) {
          leadSource = "Instagram";
        } else if (referrer.includes("tiktok.com")) {
          leadSource = "TikTok";
        } else if (referrer.includes("snapchat.com")) {
          leadSource = "Snapchat";
        } else if (
          referrer.includes("twitter.com") ||
          referrer.includes("x.com")
        ) {
          leadSource = "X";
        } else if (referrer.includes("linkedin.com")) {
          leadSource = "LinkedIn";
        } else {
          leadSource = "Organic";
        }
      } else {
        // 4. Check user agent for in-app browsers
        const userAgent = navigator.userAgent.toLowerCase();
        if (userAgent.includes("instagram")) {
          leadSource = "Instagram";
        } else if (userAgent.includes("tiktok")) {
          leadSource = "TikTok";
        } else if (userAgent.includes("snapchat")) {
          leadSource = "Snapchat";
        } else if (
          userAgent.includes("twitter") ||
          userAgent.includes("x.com")
        ) {
          leadSource = "X";
        } else {
          leadSource = "Direct";
        }
      }
    }
    setClick(clickId);

    // Only default to "Website" if no other source is identified
    if (!leadSource) {
      leadSource = "Website";
    } else {
      // Store leadSource in localStorage
      localStorage.setItem("leadSource", leadSource);
      localStorage.setItem("leadSourceTimestamp", Date.now().toString());
    }

    // console.log({
    //   urlParams: window.location.search,
    //   referrer: document.referrer,
    //   originalReferrer: localStorage.getItem("originalReferrer"),
    //   userAgent: navigator.userAgent,
    //   leadSource,
    //   clickId,
    // });

    setFormData((prevData) => ({
      ...prevData,
      leadSource: leadSource,
      language: language,
    }));
  }, []);

  // TIKTOK EVENTS API
  const trackTikTokEvent = async (event_name) => {
    if (formData.leadSource !== "TikTok") return;

    await sendTikTokEvent({
      baseUrl: base_url,
      eventName: event_name,
      phone: formData.leadContact || null,
      ttclid: click || null,
      url: window.location.href,
    });
  };

  // SNAPCHAT EVENTS API
  const trackSnapchatEvent = async (event_name) => {
    if (formData.leadSource !== "Snapchat") return;

    await sendSnapchatEvent({
      baseUrl: base_url,
      eventName: event_name,
      phone: formData.leadContact || null,
      url: window.location.href,
    });
  };

  // PHONE NUMBER
  // useEffect(() => {
  //   const phoneField = contactFieldRef.current;

  //   if (!phoneField || !showForm) return;

  //   const today = new Date().toDateString();
  //   const ipFetchedToday = localStorage.getItem('ip_fetched_today');

  //   // RUNS ONCE ON MOUNT
  //   const initializeOnce = () => {
  //     // CHECK CACHE FIRST

  //     if (ipFetchedToday === today) {
  //       console.log("✅ Cache hit - intlTelInput ONCE");
  //       const cachedData = JSON.parse(localStorage.getItem('ip_data') || '{}');
  //       setupIntlTelInput(cachedData);
  //       return;
  //     }

  //     // FETCH ONCE
  //     fetchIPOnce().then(setupIntlTelInput);
  //   };

  //   // FETCH IPAPI - ONLY ONCE PER DAY
  //   const fetchIPOnce = async () => {
  //     try {
  //       console.log("🌐 Fetching IP ONCE");
  //       const ipResponse = await fetch("https://api.ipify.org?format=json");
  //       const ipData = await ipResponse.json();

  //       const locationResponse = await fetch(`https://ipapi.co/${ipData.ip}/json`);
  //       const locationData = await locationResponse.json();

  //       const ipInfo = {
  //         ip: ipData.ip,
  //         country_code: locationData.country_code?.toLowerCase() || "ae",
  //         state: locationData.region || locationData.city || "",
  //         country_name: locationData.country_name || "United Arab Emirates",
  //         timezone: locationData.timezone || "Asia/Dubai"
  //       };

  //       // CACHE FOR TODAY
  //       localStorage.setItem('ip_data', JSON.stringify(ipInfo));
  //       localStorage.setItem('ip_fetched_today', today);

  //       return ipInfo;
  //     } catch (error) {
  //       console.error("❌ API failed");
  //       return {
  //         ip: "", country_code: "ae", state: "Dubai",
  //         country_name: "United Arab Emirates", timezone: "Asia/Dubai"
  //       };
  //     }
  //   };

  //   // intlTelInput - CALLED EXACTLY ONCE
  //   const setupIntlTelInput = (data) => {
  //     console.log("📞 intlTelInput SETUP");

  //     // DESTROY IF EXISTS
  //     // if (window.intlTelInputGlobals && phoneField) {
  //     //   const instance = window.intlTelInputGlobals.getInstance(phoneField);
  //     //   if (instance) instance.destroy();
  //     // }

  //     // TEL INPUT
  //     // const intlTelInputInstance =
  //     window.intlTelInput(
  //       // contactFieldRef.current,
  //       phoneField,
  //       {
  //         separateDialCode: true,
  //         initialCountry: "auto",
  //         geoIpLookup: (callback) => {
  //           callback(data.country_code);
  //         },
  //         utilsScript:
  //           "//cdnjs.cloudflare.com/ajax/libs/intl-tel-input/24.3.3/js/utils.js",
  //         preferredCountries: ["ae", "sa", "eg", "kw", "qa", "bh", "om"], // UAE first in preferred list
  //         nationalMode: false,
  //       }
  //     );

  //     // SET FORM DATA
  //     setFormData(prev => ({
  //       ...prev,
  //       country: `${data.state}, ${data.country_name}`,
  //       ip: data.ip,
  //       timezone: data.timezone,
  //       language: language
  //     }));

  //     setTime(getCurrentTimeInZone(data.timezone));

  //     // ADD LISTENERS ONCE
  //     phoneField.addEventListener("countrychange", handleCountryChange);
  //     phoneField.addEventListener("input", handleInputChange);

  //     // // Manually trigger an input event after initialization
  //     // setTimeout(() => {
  //     //   const event = new Event("input", { bubbles: true });
  //     //   // contactFieldRef.current.dispatchEvent(event);
  //     //   phoneField.dispatchEvent(event);
  //     // }, 300);

  //     // TRIGGER INITIAL VALIDATION
  //     setTimeout(() => {
  //       handleInputChange(); // ✅ CALL DIRECTLY
  //     }, 500);
  //   };

  //   // EVENT HANDLERS
  //   const handleCountryChange = () => {
  //     const instance = window.intlTelInputGlobals?.getInstance(phoneField);
  //     if (instance) {
  //       const countryData = instance.getSelectedCountryData();
  //       setFormData(prev => ({
  //         ...prev,
  //         country: `${formData.country || ''}`
  //       }));
  //     }
  //   };

  //   const handleInputChange = () => {
  //     const instance = window.intlTelInputGlobals?.getInstance(phoneField);
  //     if (instance) {
  //       // const phoneNumber = intlTelInputInstance.getNumber();
  //       // const countryCode = intlTelInputInstance.getSelectedCountryData().dialCode;
  //       const phoneNumber = instance.getNumber();
  //       const countryCode = instance.getSelectedCountryData().dialCode;
  //       const isValidNum = instance.isValidNumber();

  //       setCountryCode(countryCode);

  //       // if (instance.isValidNumber()) {
  //       if (isValidNum) {
  //         setIsValid(true);
  //         contactErrorRef.current.textContent = "✓";
  //         submitBtnRef.current?.removeAttribute("disabled");

  //         const localPhoneNumber = phoneNumber.replace(`+${countryCode}`, "");
  //         setLocalNumber(normalizeToLatin(localPhoneNumber, "tel"));
  //         setFormData(prev => ({ ...prev, leadContact: phoneNumber }));
  //       } else {
  //         setIsValid(false);
  //         contactErrorRef.current.textContent = "";
  //         submitBtnRef.current?.setAttribute("disabled", "true");
  //       }
  //     }
  //   };

  //   const getCurrentTimeInZone = (timezone) => {
  //     const now = new Date();
  //     return now.toLocaleTimeString('en-US', {
  //       timeZone: timezone, hour12: false, hour: '2-digit', minute: '2-digit'
  //     });
  //   };

  //   // EXECUTE
  //   if (phoneField && showForm) {
  //     initializeOnce();
  //   }

  //   // CLEAN UP ON UNMOUNT
  //   // return () => {
  //   //   if (intlTelInputInstance) {
  //   //     intlTelInputInstance.destroy();
  //   //   }
  //   // };

  //   // ✅ FIXED CLEANUP
  //   return () => {
  //     if (phoneField) {
  //       phoneField.removeEventListener("countrychange", handleCountryChange);
  //       phoneField.removeEventListener("input", handleInputChange);

  //       // Destroy instance
  //       if (window.intlTelInputGlobals && phoneField) {
  //         const instance = window.intlTelInputGlobals.getInstance(phoneField);
  //         if (instance) instance.destroy();
  //       }
  //     }
  //   };
  // }, [showForm]);

  // PHONE NUMBER - MINIMAL WORKING VERSION
  useEffect(() => {
    const phoneField = contactFieldRef.current;

    if (!phoneField || !showForm) return;

    const today = new Date().toDateString();
    const ipFetchedToday = localStorage.getItem("ip_fetched_today");

    const setupPhone = (data) => {
      console.log("📞 SETUP PHONE");

      // NO DESTROY - LET IT WORK!
      const intlTelInputInstance = window.intlTelInput(phoneField, {
        separateDialCode: true,
        initialCountry: "auto",
        geoIpLookup: (callback) => callback(data.country_code),
        utilsScript:
          "//cdnjs.cloudflare.com/ajax/libs/intl-tel-input/24.3.3/js/utils.js",
        preferredCountries: ["ae", "sa", "eg", "kw", "qa", "bh", "om"],
        nationalMode: false,
      });

      // SET FORM DATA
      setFormData((prev) => ({
        ...prev,
        country: `${data.state}, ${data.country_name}`,
        ip: data.ip,
        timezone: data.timezone,
        language: language,
      }));
      setTime(getCurrentTimeInZone(data.timezone));

      // VALIDATION LISTENER
      phoneField.addEventListener("input", () => {
        const phoneNumber = intlTelInputInstance.getNumber();
        const countryCode =
          intlTelInputInstance.getSelectedCountryData().dialCode;
        setCountryCode(countryCode);
        if (intlTelInputInstance.isValidNumber()) {
          setIsValid(true);
          contactErrorRef.current.textContent = "✓";
          submitBtnRef.current.removeAttribute("disabled");
          const localPhoneNumber = phoneNumber.replace(`+${countryCode}`, "");
          // setLocalNumber(localPhoneNumber);
          setLocalNumber(normalizeToLatin(localPhoneNumber, "tel"));

          setFormData((prevData) => ({
            ...prevData,
            leadContact: phoneNumber,
          }));
        } else {
          setIsValid(false);
          // contactErrorRef.current.textContent = t("validation_phone");
          contactErrorRef.current.textContent = "";
          submitBtnRef.current.setAttribute("disabled", "true");
        }
      });

      // COUNTRY CHANGE
      // phoneField.addEventListener("countrychange", () => {
      //   const countryData = intlTelInputInstance.getSelectedCountryData();
      //   setFormData((prevData) => ({
      //     ...prevData,
      //     country: state + ", " + countryData.name,
      //     ip: userIp,
      //     language: language
      //   }));
      // });
    };

    // LOAD DATA
    if (ipFetchedToday === today) {
      const cachedData = JSON.parse(localStorage.getItem("ip_data") || "{}");
      setupPhone(cachedData);
    } else {
      // FETCH ONCE
      fetch("https://api.ipify.org?format=json")
        .then((ipRes) => ipRes.json())
        .then((ipData) =>
          fetch(`https://ipapi.co/${ipData.ip}/json`)
            .then((locRes) => locRes.json())
            .then((locationData) => {
              const ipInfo = {
                ip: ipData.ip,
                country_code: locationData.country_code?.toLowerCase() || "ae",
                state: locationData.region || locationData.city || "",
                country_name:
                  locationData.country_name || "United Arab Emirates",
                timezone: locationData.timezone || "Asia/Dubai",
              };
              localStorage.setItem("ip_data", JSON.stringify(ipInfo));
              localStorage.setItem("ip_fetched_today", today);
              setupPhone(ipInfo);
            }),
        )
        .catch(() => {
          // FALLBACK
          const fallback = {
            ip: "",
            country_code: "ae",
            state: "Dubai",
            country_name: "United Arab Emirates",
            timezone: "Asia/Dubai",
          };
          localStorage.setItem("ip_data", JSON.stringify(fallback));
          localStorage.setItem("ip_fetched_today", today);
          setupPhone(fallback);
        });
    }
  }, []); // RUNS ONCE

  const getCurrentTimeInZone = (timezone) => {
    const now = new Date();
    return now.toLocaleTimeString("en-US", {
      timeZone: timezone,
      hour12: false,
      hour: "2-digit",
      minute: "2-digit",
    });
  };

  // FORMAT TIME TO 12-HOUR WITH AM/PM
  const formatTimeTo12Hour = (time24) => {
    if (!time24) return "";
    const [hours, minutes] = time24.split(":");
    let hoursNum = parseInt(hours, 10);
    const ampm = hoursNum >= 12 ? "PM" : "AM";
    hoursNum = hoursNum % 12 || 12; // Convert 0 or 12 to 12
    const formattedHours = hoursNum.toString().padStart(2, "0");
    return `${formattedHours}:${minutes} ${ampm}`;
  };

  // HANDLE TIME CHANGE
  const handleTimeChange = (e) => {
    const timeValue = e.target.value;
    setTime(timeValue);
    const formattedTime = formatTimeTo12Hour(timeValue); // e.g., "01:30 PM"
    setFormData((prevData) => ({
      ...prevData,
      notes: formattedTime ? `${formattedTime}` : "",
      time: formattedTime ? `${formattedTime}` : "",
    }));
  };

  // HANDLE TIME INPUT CLICK
  const handleTimeClick = () => {
    if (timeInputRef.current) {
      timeInputRef.current.showPicker();
    }
  };

  // HANDLE CHANGE
  const handleChange = (e) => {
    const { name, value } = e.target;
    if (name === "leadContact") {
      const normalizedValue = normalizeToLatin(value, "tel");
      setLocalNumber(normalizedValue);
      setFormData((prevData) => ({
        ...prevData,
        leadContact: countryCode + normalizedValue,
      }));
      // setFormData((prevData) => ({
      //   ...prevData,
      //   leadContact: countryCode + value,
      // }));
    } else if (name === "leadEmail") {
      const normalizedValue = normalizeToLatin(value, "email");
      setFormData((prevData) => ({
        ...prevData,
        leadEmail: normalizedValue,
      }));
    } else if (name === "leadType") {
      setSelectedPropertyType(value);
      setFormData((prevData) => ({
        ...prevData,
        leadType: value,
        enquiryType: "", // Reset enquiryType when property type changes
      }));
    } else if (name === "leadName") {
      const normalizedValue = normalizeToLatin(value, "name");
      setFormData((prevData) => ({
        ...prevData,
        leadName: normalizedValue,
      }));
    } else if (name === "enquiryType") {
      const bedroomOptions = getBedroomOptions() || [];
      const normalized = bedroomOptions.map(normalizeOption);
      const matched = normalized[Number(value)]; // value is now the option's index

      setFormData((prevData) => ({
        ...prevData,
        enquiryType: matched?.option?.value ?? "",
        ...(matched?.option?.leadType && !isNewLeadTypeFormat
          ? { leadType: matched.option.leadType }
          : {}),
      }));
    }
    else {
      setFormData((prevData) => ({
        ...prevData,
        [name]: value,
      }));
    }
  };

  // VALIDATE FORM DATA
  const validate = () => {
    const newErrors = {};
    if (!formData.leadName) newErrors.leadName = t("validation_name");
    if (!formData.leadContact) newErrors.leadContact = t("validation_phone");
    if (enquiries && !formData.enquiryType)
      newErrors.enquiryType = t("validation_enquiry");
    // if (purpose && !formData.leadFor) newErrors.leadFor = t("validation_enquiry");
    if (isNewLeadTypeFormat && !formData.leadType)
      newErrors.leadType = t("validation_property_type");
    return newErrors;
  };

  // PAGE VIEW TIKTOK
  // useEffect(() => {
  //   sendTikTokEvent({
  //     baseUrl: base_url,
  //     eventName: "PageView",
  //     ttclid: click || "",
  //     url: window.location.href,
  //   });
  // }, []);

  useEffect(() => {
    if (formData.leadSource === "TikTok") {
      trackTikTokEvent("PageView");
    }
    if (formData.leadSource === "Snapchat") {
      trackSnapchatEvent("PageView");
    }
  }, [formData.leadSource]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    submitBtnRef.current.setAttribute("disabled", "true");

    const newErrors = validate();
    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      submitBtnRef.current.removeAttribute("disabled");
      return;
    }

    setErrors({});
    setLoading(true);

    // TIKTOK
    // Identify user with hashed PII data before tracking events
    // identifyUser({
    //   // email: formData?.leadEmail || "",
    //   phone_number: formData?.leadContact,
    // });

    // Event data for OTP-related events (simplified structure)
    // const otpEventData = {
    //   event: 'OTP NOT VERIFIED',
    //   event_time: Math.floor(Date.now() / 1000),
    //   user: {
    //     phone: formData?.leadContact ? hashData(formData?.leadContact) : '', // Hashed phone
    //     ttclid: click || null,
    //     ip: formData?.ip || '',
    //     user_agent: formData?.device || navigator.userAgent,
    //   },
    //   page: {
    //     url: window.location.href,
    //   },
    //   contents: [
    //     {
    //       content_name: "OTP NOT VERIFIED",
    //     },
    //   ],
    //   event_id: CryptoJS.lib.WordArray.random(16).toString(),
    // };

    try {
      // CHECK FOR BLOCKED IP
      const ip = formData.ip || userInfo?.ip || "";
      if (ip) {
        const checkBlockedResponse = await axios.get(
          `${base_url}checkBlocked?ip=${encodeURIComponent(ip)}`,
        );
        const checkBlockedData = checkBlockedResponse.data;

        // console.log("CheckBlocked response:", checkBlockedData);

        // Check if IP is blocked (status: true means blocked)
        if (checkBlockedData.status === true) {
          // console.log("IP is blocked");
          setLoading(false);
          submitBtnRef.current.removeAttribute("disabled");
          navigate("/blocked");
          return;
        }
      }

      // SEND EMAIL FOR BACKUP
      const sendBackupEmail = async (payload) => {
        try {
          const url = process.env.REACT_APP_BASE_URL;
          // const url = "http://127.0.0.1:8000/";
          await axios.post(
            `${url}backend/controllers/AddLeadSendMail.php`,
            payload,
            {
              headers: {
                "Content-Type": "application/json",
              },
              timeout: 50000, // don’t hang the form
            }
          );
          console.log("📧 Backup email sent");
        } catch (err) {
          console.error("📧 Backup email failed (ignored):", err?.response?.data || err.message);
        }
      };
      try {
        sendBackupEmail({
          ...formData,
          clientEmail: "workofmuskan@gmail.com",
        });
      } catch (error) {
        console.error(error);
        setLoading(false);
      }

      // SAVE DATA THROUGH API
      const response = await axios.post(`${base_url}create-lead`, formData, {
        headers: {
          "Content-Type": "application/json",
        },
      });

      // const response = await axios.post(`https://nina.dodealcrm.com/api/create-lead`, formData, {
      //   headers: {
      //     "Content-Type": "application/json",
      //   },
      // });

      // NEW: Log FULL response
      console.log("FULL RESPONSE:", response);
      console.log("STATUS:", response.status);
      console.log("HEADERS:", response.headers);
      console.log("RAW DATA:", response.data); // This is resData

      const resData = response.data;

      if (
        resData.status &&
        resData.lead &&
        resData.lead.id &&
        resData.lead.otp_code
      ) {
        setServerOtp(resData.lead.otp_code);
        setLeadId(resData.lead.id);
        setShowForm(false);
        setShowOtpForm(true);
        setLoading(false);
        localStorage.setItem("leadFormSubmission", Date.now().toString());

        await trackTikTokEvent("Lead");
        await trackSnapchatEvent("Lead");

        // Optionally track CompleteRegistration if this is a registration step
        // trackCompleteRegistration(standardEventData);
      } else if (
        resData.status &&
        resData.lead &&
        resData.lead.id &&
        resData.lead.otp_code < "99999"
      ) {
        setShowForm(false);
        setLoading(false);
        setShowOtpForm(false);
        localStorage.setItem("leadFormSubmission", Date.now().toString());

        // await trackTikTokEvent("CompleteRegistration");
        const newPath =
          language === "Arabic"
            ? `/thankyou/ar?lead-form-submit=true`
            : language === "Farsi"
              ? "/thankyou/fa?lead-form-submit=true"
              : "/thankyou?lead-form-submit=true";
        window.location.assign(newPath); // Forces full page reload
      } else {
        setShowForm(false);
        setLoading(false);
        setShowOtpForm(false);
        const newPath =
          language === "Arabic"
            ? `/thankyou/ar`
            : language === "Farsi"
              ? "/thankyou/fa"
              : "/thankyou";
        window.location.assign(newPath); // Forces full page reload
      }
    } catch (error) {
      console.error("Axios error:", error);
      if (error.response) {
        console.log("Response Text:", error.response.data);
      }
      setLoading(false);
      submitBtnRef.current.removeAttribute("disabled");
    }
  };

  const handleOtpPaste = (e) => {
    // const pastedData = e.clipboardData.getData("text").replace(/[^0-9]/g, "").slice(0, 6);
    const pastedData = e.clipboardData
      .getData("text")
      .split("")
      .map((char) => normalizeToLatin(char, "otp"))
      .join("")
      .slice(0, 6);
    const newOtp = ["", "", "", "", "", ""];
    for (let i = 0; i < pastedData.length && i < 6; i++) {
      newOtp[i] = pastedData[i];
    }
    setOtp(newOtp);
  };

  // Keep your existing handleOtpChange and handleOtpKeyDown
  const handleOtpChange = (index, value) => {
    const normalized = normalizeToLatin(value, "otp");
    if (!/^\d?$/.test(normalized)) return;

    const newOtp = [...otp];
    newOtp[index] = normalized;
    setOtp(newOtp);

    if (normalized && index < 5) {
      otpRefs.current[index + 1]?.focus();
    }

    // Auto-submit when complete
    if (newOtp.every((d) => d !== "")) {
      setTimeout(() => handleOtpSubmit(), 300);
    }
  };

  const handleOtpKeyDown = (index, e) => {
    if (e.key === "Backspace" && !otp[index] && index > 0) {
      otpRefs.current[index - 1]?.focus();
    }
  };

  const handleOtpSubmit = async () => {
    setLoading(true);
    // TIKTOK
    // Identify user with hashed PII data before tracking events
    // identifyUser({
    //   email: formData?.leadEmail || "",
    //   phone_number: formData?.leadContact,
    // });

    // Event data for OTP-related events (simplified structure)
    // const otpEventData = {
    //   event: 'OTP VERIFIED',
    //   event_time: Math.floor(Date.now() / 1000),
    //   user: {
    //     phone: formData?.leadContact ? hashData(formData?.leadContact) : '', // Hashed phone
    //     ttclid: click || null,
    //     ip: formData?.ip || '',
    //     user_agent: formData?.device || navigator.userAgent,
    //   },
    //   page: {
    //     url: window.location.href,
    //   },
    //   contents: [
    //     {
    //       content_name: "OTP VERIFIED",
    //     },
    //   ],
    //   event_id: CryptoJS.lib.WordArray.random(16).toString(),
    // };

    if (otp.every((digit) => digit !== "") && otp.length === 6) {
      const otpValue = otp.join("");
      if (otpValue === String(serverOtp)) {
        setLoading(true);
        try {
          await verifyOtp(otpValue);
          setShowOtpForm(false);
        } catch (error) {
          console.error(error);
        } finally {
          setLoading(false);
        }
      } else {
        setLoading(false);
        setAttempts((prev) => prev + 1);
        setOtpError(t("otp_invalid"));
        setOtp(["", "", "", "", "", ""]);
        otpRefs.current[0].focus();
      }
    } else {
      setLoading(false);
      // setOtpError(t("otp_incomplete"));
    }
  };

  const handleResendOtp = async () => {
    if (isResendDisabled) return;
    setLoading(true);
    setIsResendDisabled(true);
    setResendTimer(60);
    try {
      const response = await axios.post(
        `${base_url}resend-lead-otp/${leadId}`,
        {},
        {
          headers: {
            "Content-Type": "application/json",
          },
        },
      );
      const resData = response.data;

      if (resData.status && resData.lead && resData.lead.otp_code) {
        setServerOtp(resData.lead.otp_code);
        setAttempts(0);
        setOtpError("");
        setOtp(["", "", "", "", "", ""]);
        otpRefs.current[0].focus();
      } else {
        setOtpError(t("resend_failed"));
      }
    } catch (error) {
      console.error("Resend OTP error:", error);
      setOtpError(t("resend_failed"));
    } finally {
      setLoading(false);
    }
  };

  const verifyOtp = async (otpInput) => {
    if (attempts >= 5) {
      setOtpError(t("max_attempts_reached"));
      return;
    }

    setLoading(true);
    try {
      const response = await axios.post(
        `${base_url}verify-lead-otp/${leadId}`,
        { otp: "Verified" },
        {
          headers: {
            "Content-Type": "application/json",
          },
        },
      );

      const resData = response.data;
      console.log("OTP API Response:", resData);

      if (resData.status) {
        await trackTikTokEvent("CompleteRegistration");
        await trackSnapchatEvent("CompleteRegistration");
        setLoading(false);
        setShowOtpForm(false);
        // navigate(
        //   language === "Arabic"
        //     ? "/thankyou/ar?lead-form-submit=true"
        //     : language === "Farsi"
        //       ? "/thankyou/fa?lead-form-submit=true"
        //       : "/thankyou?lead-form-submit=true"
        // );
        // Full page reload to /thankyou page
        const newPath =
          language === "Arabic"
            ? "/thankyou/ar?lead-form-submit=true"
            : language === "Farsi"
              ? "/thankyou/fa?lead-form-submit=true"
              : "/thankyou?lead-form-submit=true";
        // window.location.assign(newPath); // Forces full page reload
        setTimeout(() => {
          window.location.assign(newPath);
        }, 100); // 100ms delay is usually enough
      } else {
        setAttempts((prev) => prev + 1);
        setOtpError(t("otp_invalid"));
        setOtp(["", "", "", "", "", ""]);
        setLoading(false);
        otpRefs.current[0].focus();
      }
    } catch (error) {
      console.error("OTP verification error:", error);
      setAttempts((prev) => prev + 1);
      setOtpError(t("otp_invalid"));
      setOtp(["", "", "", "", "", ""]);
      setLoading(false);
      otpRefs.current[0].focus();
    }
  };

  return (
    <>
      {loading && <Loading />}
      <div className="py-2 flex justify-center items-center">
        <div className="no-form-container" id="form-container">
          {showForm ? (
            <form
              id="lead-form"
              name="lead-form"
              // dir="ltr"
              onSubmit={handleSubmit}
            >
              {/* NAME */}
              <label htmlFor="leadName" className="mt-0 font-bold">
                {t("name")}
                <div
                  className={`${formData.leadName ? "flex" : "hidden"} text-green-700 rounded-full aspect-square font-light`}
                >
                  ✓
                </div>
              </label>
              <input
                type="text"
                name="leadName"
                id="leadName"
                value={formData.leadName}
                // placeholder={t("name")}
                onChange={handleChange}
                required
                autoComplete="true"
              />
              {errors.leadName && (
                <small className="bg-red-600 text-white">
                  {errors.leadName}
                </small>
              )}

              {/* CONTACT NUMBER */}
              <label htmlFor="leadContact" className="font-bold">
                {t("contact")}
                <div
                  id="contactError"
                  ref={contactErrorRef}
                  className={`text-green-700 rounded-full aspect-square font-light`}
                ></div>
              </label>
              {/* <div dir="ltr"> */}
              <input
                type="tel"
                ref={contactFieldRef}
                name="leadContact"
                id="leadContact"
                placeholder=" "
                // value={localNumber}
                // onChange={handleChange}
                required
                autoComplete="true"
              />
              {/* </div> */}

              {/* EMAIL */}
              {askEmail || isOutsideUAE ? (
                <>
                  <label htmlFor="leadEmail" className="font-bold">
                    {t("email")}
                  </label>
                  <input
                    type="email"
                    name="leadEmail"
                    id="leadEmail"
                    value={formData.leadEmail}
                    onChange={handleChange}
                    required
                    autoComplete="true"
                  />
                </>
              ) : null}

              {isNewLeadTypeFormat && (
                <>
                  <label className="font-bold">{t("property_type")}</label>
                  <div className="flex flex-wrap gap-2 justify-center items-center">
                    {Object.keys(leadType[0]).map((type) => {
                      const option = propertyConfig[type];
                      return (
                        option && (
                          <div
                            key={type}
                            className="property-radio-luxury flex items-center justify-center h-full flex-1"
                          >
                            <input
                              className="mx-2"
                              type="radio"
                              name="leadType"
                              id={`PropertyType${type}`}
                              value={option.value}
                              checked={selectedPropertyType === option.value}
                              onChange={handleChange}
                              required
                            />
                            <label
                              htmlFor={`PropertyType${type}`}
                              className="m-0 flex flex-col gap-2 items-center justify-center"
                            >
                              <div className="flex items-center px-2">
                                {option.icon}
                              </div>
                              <div className="px-2">{option.label}</div>
                            </label>
                          </div>
                        )
                      );
                    })}
                  </div>
                  {errors.leadType && (
                    <small className="bg-red-600 text-white">
                      {errors.leadType}
                    </small>
                  )}
                </>
              )}

              {/* HOW MANY BEDROOMS */}
              {enquiries ? (() => {
                // const bedroomOptions = getBedroomOptions() || [];
                // const validOptions = bedroomOptions.map((key) => ({ key, option: optionsConfig[key] })).filter((item) => item.option);
                // if (validOptions.length <= 1) return null;

                // const validOptions = bedroomOptions.map((key) => {
                //   const option = optionsConfig[key];
                //   if (option) return { key, option };
                //   // Not a known key — use the raw enquiries string directly
                //   return { key, option: { value: key, label: key } };
                // });

                const bedroomOptions = getBedroomOptions() || [];
                const validOptions = bedroomOptions.map(normalizeOption);

                return (
                  <>
                    <label className="font-bold">{t("bedrooms")}</label>
                    <div className="relative w-full flex justify-end">
                      <select
                        id="enquiryType"
                        name="enquiryType"
                        required
                        onChange={handleChange}
                        className="w-full appearance-none"
                      >
                        <option value="" disabled selected>
                          {t("bedrooms")}
                        </option>

                        {/* {validOptions().map((key) => {
                          const option = optionsConfig[key];
                          return (
                            option && (
                              <option key={key} value={option.value}>
                                {option.label}
                              </option>
                            )
                          );
                        })} */}

                        {/* {validOptions.map(({ key, option }) => (
                          <option key={key} value={option.value}>
                            {option.label}
                          </option>
                        ))} */}
                        {validOptions.map(({ key, option }, index) => (
                          <option key={key} value={index}>
                            {option.label}
                          </option>
                        ))}
                      </select>
                      <div className="absolute top-1/2 transform -translate-y-1/2 z-1 text-white pointer-events-none px-4">
                        <BsChevronDown size={16} />
                      </div>
                    </div>
                    {errors.enquiryType && (
                      <small className="bg-red-600 text-white">
                        {errors.enquiryType}
                      </small>
                    )}
                  </>
                );
              })() : null}

              {purpose ? (
                <>
                  <label className="font-bold">{t("purpose")}</label>
                  <div className="relative w-full flex justify-end">
                    <select
                      id="leadFor"
                      name="leadFor"
                      required
                      onChange={handleChange}
                      className="w-full appearance-none"
                    >
                      <option value="" disabled selected>
                        {t("purpose")}
                      </option>
                      <option value={"Investment"}>{t("investment")}</option>
                      <option value={"End-user"}>{t("end-user")}</option>
                    </select>
                    <div className="absolute top-1/2 transform -translate-y-1/2 z-1 text-white pointer-events-none px-4">
                      <BsChevronDown size={16} />
                    </div>
                  </div>
                </>
              ) : null}

              {/* PREFERRED CONTACT TIME */}
              {contactTime ? (
                <>
                  <label htmlFor="time">{t("preferred_time")}</label>
                  <input
                    type="time"
                    name="time"
                    id="time"
                    ref={timeInputRef}
                    value={time}
                    onChange={handleTimeChange}
                    onClick={handleTimeClick}
                    placeholder="01:30 PM"
                    className="w-full"
                    required
                    style={{
                      paddingTop: "10px !important",
                    }}
                  />
                </>
              ) : null}

              <div className="relative mt-6">
                <button
                  type="submit"
                  className={`submit-btn w-full font-bold ${color == "gold" ? "primary-bg" : bgMap[color]} text-white`}
                  id="submit-btn"
                  ref={submitBtnRef}
                  disabled={false}
                >
                  {t("submit")}
                </button>
              </div>
            </form>
          ) : showOtpForm ? (
            <>
              <div
                className="bg-black fixed top-0 left-0 w-[100vw] h-[100vh] overflow-y-auto padding-container flex flex-col items-center justify-start gap-12 !pt-2 !pb-20"
                style={{ zIndex: 1001 }}
              >
                {/* LOGO */}
                <div className="flex justify-end w-full">
                  <img
                    src="/assets/images/logo/dodeal-properties-white.png"
                    alt="DODEAL PROPERTIES"
                    className="h-[40px] w-auto self-end"
                  />
                </div>
                <div className="flex flex-col items-center justify-start gap-6 text-center">
                  {/* TEXT */}
                  <h3
                    className={`${textMap[color]} ${neonMap[color]} text-2xl lg:text-3xl font-bold`}
                  >
                    رمز التحقق
                  </h3>
                  {/* GRAPHIC */}
                  <img
                    src="/assets/images/icons/otpimg.svg"
                    alt="DODEAL PROPERTIES"
                    className={`w-[200px] lg:w-[300px] ${vectorMap[color]}`}
                  />
                  {/* LONG TEXT */}
                  <h3
                    className={`font-bold flex gap-2 items-center justify-center flex-wrap breal-all ${textMap[color]}`}
                  >
                    {/* <h3 className="font-semibold"> */}
                    {/* {t("enter_otp")} */}
                    <span className="break-all">
                      {/* ، يرجى نسخ الكود وإدخاله لتأكيد اهتمامك */}
                      تم إرسال كود التأكيد إلي الواتساب
                    </span>
                    <span>
                      <PiWhatsappLogoDuotone
                        className="text-green-400"
                        size={22}
                      />
                    </span>
                    <span className="break-all">
                      {/* تم إرسال كود التأكيد إلى الواتساب */}
                      يرجي نسخ الكود وإدخاله لتأكيد اهتمامك
                    </span>
                  </h3>
                  {isAndroid ? (
                    <div className="flex justify-center">
                      <input
                        type="tel"
                        inputMode="numeric"
                        autoComplete="one-time-code sms-otp"
                        pattern="\d{0,6}"
                        maxLength="6"
                        value={otp.join("")}
                        onChange={(e) => {
                          const val = e.target.value
                            .replace(/\D/g, "")
                            .slice(0, 6);
                          const digits = val.padEnd(6, "").split("");
                          setOtp(digits);
                        }}
                        onPaste={(e) => {
                          e.preventDefault();
                          const pasted = e.clipboardData
                            .getData("text")
                            .replace(/\D/g, "")
                            .slice(0, 6);
                          setOtp(pasted.padEnd(6, "").split(""));
                        }}
                        placeholder="______"
                        className="w-full max-w-[500px] text-center text-lg font-bold tracking-widest rounded-2xl focus:border-white outline-none text-white"
                        style={{ letterSpacing: "1rem", paddingLeft: "1rem" }}
                        autoFocus
                      />
                    </div>
                  ) : (
                    <div className="w-fit flex">
                      <div className="grid grid-cols-6 gap-3" dir="ltr">
                        {otp.map((digit, index) => (
                          <input
                            key={index}
                            type="text"
                            inputMode="numeric"
                            maxLength="1"
                            pattern="[0-9]*"
                            value={digit}
                            onChange={(e) =>
                              handleOtpChange(index, e.target.value)
                            }
                            onKeyDown={(e) => handleOtpKeyDown(index, e)}
                            onPaste={index === 0 ? handleOtpPaste : undefined}
                            // onPaste={handlePaste}  // IMPORTANT → apply paste on ALL inputs
                            ref={(el) => (otpRefs.current[index] = el)}
                            disabled={attempts >= 5}
                            className="otp-input-lp2 text-center text-lg font-medium focus:outline-none focus:ring-2 focus:ring-white aspect-square !p-1"
                            placeholder=""
                          />
                        ))}
                      </div>
                    </div>
                  )}
                  {otpError && (
                    <p className="text-red-600">
                      {otpError}
                      {/* رمز التحقق غير صحيح. يرجى التأكد من الرمز والمحاولة مجددًا */}
                    </p>
                  )}
                  {attempts >= 5 && (
                    <p className="text-red-600">
                      {t("max_attempts_reached")}
                      {/* تم الوصول إلى الحد الأقصى لعدد المحاولات! */}
                    </p>
                  )}
                </div>
                <div className="flex flex-col items-center justify-center w-full max-w-[300px] gap-4 mb-8">
                  <button
                    type="submit"
                    className={`submit-btn w-full max-w-[300px] font-bold ${color == "gold" ? "primary-bg" : bgMap[color]} hover:${textMap[color]}`}
                    ref={otpSubmitBtnRef}
                    onClick={handleOtpSubmit}
                    id="otp-btn"
                    disabled={
                      attempts >= 5 || !otp.every((digit) => digit !== "")
                    }
                  >
                    {t("send_otp")}
                  </button>
                  {/* <div
                    onClick={handleResendOtp}
                    className={`primary-text text-center ${isResendDisabled ? "opacity-50" : "cursor-pointer"}`}
                  >
                    {t("resend_otp")}
                  </div>
                  {isResendDisabled && (
                    <small className="text-white">
                      {t("resend_available_in")} {resendTimer}s
                    </small>
                  )} */}
                </div>
              </div>
            </>
          ) : (
            <div className="p-6 text-center my-5">
              {/* {t("thankyou")} */}
              <span className="text-white">
                {language === "Arabic"
                  ? "شكرا لتواصلك معنا."
                  : language === "Farsi"
                    ? "سپاس از اینکه با ما در ارتباط هستید"
                    : "Thank you for reaching out to us."}
                &nbsp;
              </span>
              <br />
              {language === "Arabic"
                ? "سيتواصل معك مستشارنا المخصص قريبًا لتلبية احتياجاتك."
                : language === "Farsi"
                  ? "کارشناس ما در کوتاه‌ترین زمان با شما تماس می‌گیرد تا درخواستتان را پیگیری کند."
                  : "Our dedicated consultant will be in contact with you shortly to address your needs."}
              &nbsp;
            </div>
          )}
        </div>
      </div>
    </>
  );
};
export default ColorLeadForm;
